export const FILTER_GROUP_KEY_ACTIVITY_BY_TYPE = 'activityByType';
export const FILTER_GROUP_KEY_ACTIVITY_BY_STATUS = 'activityByStatus';
export const FILTER_GROUP_KEY_ACTIVITY = 'activity';
